import { render, staticRenderFns } from "./TrainingCalendarWeekSummary.vue?vue&type=template&id=329495d4&scoped=true&"
import script from "./TrainingCalendarWeekSummary.vue?vue&type=script&lang=ts&"
export * from "./TrainingCalendarWeekSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCalendarWeekSummary.vue?vue&type=style&index=0&id=329495d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329495d4",
  null
  
)

export default component.exports